import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-attendance`
let baseUrl2 = `${httpUrl.host}/gy-guard`
let baseUrl85 = `${httpUrl.host}/gy-apartment`

let api = {
  // 部门管理——分页
  getAttendanceDeptPage: `${baseUrl}/attendanceDept/getPage`,

  // 部门管理——添加
  addAttendanceDept: `${baseUrl}/attendanceDept/add`,

  // 部门管理——详情
  getAttendanceDeptByCode: `${baseUrl}/attendanceDept/getByCode`,

  // 部门管理——修改
  updateAttendanceDept: `${baseUrl}/attendanceDept/update`,

  // 部门管理——删除
  deleteAttendanceDeptByCode: `${baseUrl}/attendanceDept/deleteByCodes`,

  // 部门管理——列表
  getAttendanceDeptList: `${baseUrl}/attendanceDept/getList`,

  // 岗位管理——分页
  getAttendancePositionPage: `${baseUrl}/attendancePosition/getPage`,

  // 岗位管理——添加
  addAttendancePosition: `${baseUrl}/attendancePosition/add`,

  // 岗位管理——详情
  getAttendancePositionByCode: `${baseUrl}/attendancePosition/getByCode`,

  // 岗位管理——修改
  updateAttendancePosition: `${baseUrl}/attendancePosition/update`,

  // 岗位管理——删除
  deleteAttendancePositionByCode: `${baseUrl}/attendancePosition/deleteByCodes`,

  // 岗位管理——列表
  getAttendancePositionList: `${baseUrl}/attendancePosition/getList`,

  // 岗位管理——出勤天数分页
  getPositionDaysPage: `${baseUrl}/positionDays/getPage`,

  // 岗位管理——出勤天数修改
  updatePositionDays: `${baseUrl}/positionDays/update`,

  // 人员管理——获取园区人员
  getResponsiblePersonList: `${baseUrl85}/person/getResponsiblePersonList`,

  // 人员管理——获取园区所有人员
  getAllPersonInfo: `${baseUrl85}/person/getAllPersonInfo`,

  // 人员管理——分页
  getAttendancePersonPage: `${baseUrl}/attendancePerson/getPage`,

  // 人员管理——添加
  addAttendancePerson: `${baseUrl}/attendancePerson/add`,

  // 人员管理——详情
  getAttendancePersonByCode: `${baseUrl}/attendancePerson/getByCode`,

  // 人员管理——修改
  updateAttendancePerson: `${baseUrl}/attendancePerson/update`,

  // 人员管理——删除
  deleteAttendancePersonByCode: `${baseUrl}/attendancePerson/deleteByCodes`,

  // 人员管理——列表
  getAttendancePersonList: `${baseUrl}/attendancePerson/getList`,

  // 加班配置——分页
  getAttendanceOvertimePage: `${baseUrl}/attendanceOvertime/getPage`,

  // 加班配置——添加
  addAttendanceOvertime: `${baseUrl}/attendanceOvertime/add`,

  // 加班配置——详情
  getAttendanceOvertimeByCode: `${baseUrl}/attendanceOvertime/getByCode`,

  // 加班配置——修改
  updateAttendanceOvertime: `${baseUrl}/attendanceOvertime/update`,

  // 加班配置——删除
  deleteAttendanceOvertimeByCode: `${baseUrl}/attendanceOvertime/deleteByCodes`,

  // 加班配置——列表
  getAttendanceOvertimeList: `${baseUrl}/attendanceOvertime/getList`,

  // 考勤点管理——分页
  getAttendancePointPage: `${baseUrl}/attendancePoint/getPage`,

  // 考勤点管理——添加
  addAttendancePoint: `${baseUrl}/attendancePoint/add`,

  // 考勤点管理——详情
  getAttendancePointByCode: `${baseUrl}/attendancePoint/getByCode`,

  // 考勤点管理——修改
  updateAttendancePoint: `${baseUrl}/attendancePoint/update`,

  // 考勤点管理——删除
  deleteAttendancePointByCodes: `${baseUrl}/attendancePoint/deleteByCodes`,

  // 考勤点管理——设备列表
  getAccessDeviceListByAttendance: `${baseUrl2}/accessDevice/getListByAttendance`,

  // 班组管理——分页
  getAttendanceGroupPage: `${baseUrl}/attendanceGroup/getPage`,

  // 班组管理——添加
  addAttendanceGroup: `${baseUrl}/attendanceGroup/add`,

  // 班组管理——详情
  getAttendanceGroupByCode: `${baseUrl}/attendanceGroup/getByCode`,

  // 班组管理——修改
  updateAttendanceGroup: `${baseUrl}/attendanceGroup/update`,

  // 班组管理——删除
  deleteAttendanceGroupByCodes: `${baseUrl}/attendanceGroup/deleteByCodes`,

  // 班组管理——查询人员列表
  getListByUnbound: `${baseUrl}/attendancePerson/getListByUnbound`,

  // 班组管理——获取未绑定班次的班组列表
  getAttendanceGroupListForUnboundClasses: `${baseUrl}/attendanceGroup/getListForUnboundClasses`,

  // 班次管理——分页
  getAttendanceClassPage: `${baseUrl}/attendanceClass/getPage`,

  // 班次管理——添加
  addAttendanceClass: `${baseUrl}/attendanceClass/add`,

  // 班次管理——详情
  getAttendanceClassByCode: `${baseUrl}/attendanceClass/getByCode`,

  // 班次管理——修改
  updateAttendanceClass: `${baseUrl}/attendanceClass/update`,

  // 班次管理——删除
  deleteAttendanceClassByCodes: `${baseUrl}/attendanceClass/deleteByCodes`,

  // 班次管理——列表
  getAttendanceClassList: `${baseUrl}/attendanceClass/getList`,

  // 获取考勤配置
  getAttendanceConfig: `${baseUrl}/attendanceConfig/get`,

  // 修改考勤配置
  saveAttendanceConfig: `${baseUrl}/attendanceConfig/save`,

  // 排班管理——分页
  getGroupClassesRelationPage: `${baseUrl}/groupClassesRelation/getPage`,

  // 排班管理——添加班组
  addGroupClassesRelation: `${baseUrl}/groupClassesRelation/add`,

  // 排班管理——删除
  deleteGroupClassesRelationByCodes: `${baseUrl}/groupClassesRelation/deleteByCodes`,

  // 排班管理——详情
  getGroupClassesRelationByCode: `${baseUrl}/groupClassesRelation/getByCode`,

  // 排班管理——班组排班列表查询
  getAttendanceScheduleList: `${baseUrl}/attendanceSchedule/list`,

  // 排班管理——保存
  saveAttendanceSchedule: `${baseUrl}/attendanceSchedule/save`,

  // 排班管理——查询所有人员排班记录
  getAttendanceScheduleAll: `${baseUrl}/attendanceSchedule/getAll`,

  // 调班管理——分页
  getAttendanceReplacePage: `${baseUrl}/attendanceReplace/getPage`,

  // 已排班人员列表
  getAttendanceGroupUserList: `${baseUrl}/attendanceGroup/userList`,

  // 调班管理——查询人员原班次
  getUserAttendanceSchedule: `${baseUrl}/attendanceSchedule/getUserSchedule`,

  // 调班管理——查询人员可调班次
  getAttendancePersonClassesList: `${baseUrl}/attendancePerson/getClassesList`,

  // 调班管理——添加
  addAttendanceReplace: `${baseUrl}/attendanceReplace/add`,

  // 调班管理——详情
  getAttendanceReplaceByCode: `${baseUrl}/attendanceReplace/getByCode`,

  // 调班管理——修改
  updateAttendanceReplace: `${baseUrl}/attendanceReplace/update`,

  // 调班管理——删除
  deleteAttendanceReplaceByCodes: `${baseUrl}/attendanceReplace/deleteByCodes`,

  // 假期管理——分页
  getAttendanceHolidayPage: `${baseUrl}/attendanceHoliday/getPage`,

  // 假期管理——添加
  addAttendanceHoliday: `${baseUrl}/attendanceHoliday/add`,

  // 假期管理——详情
  getAttendanceHolidayByCode: `${baseUrl}/attendanceHoliday/getByCode`,

  // 假期管理——修改
  updateAttendanceHoliday: `${baseUrl}/attendanceHoliday/update`,

  // 假期管理——删除
  deleteAttendanceHolidayByCodes: `${baseUrl}/attendanceHoliday/deleteByCodes`,

  // 加班申请——分页
  getOvertimePage: `${baseUrl}/overtime/getPage`,

  // 加班申请——添加
  addOvertime: `${baseUrl}/overtime/add`,

  // 加班申请——详情
  getOvertimeByCode: `${baseUrl}/overtime/getByCode`,

  // 加班申请——修改
  updateOvertime: `${baseUrl}/overtime/update`,

  // 加班申请——删除
  deleteOvertimeByCodes: `${baseUrl}/overtime/deleteByCodes`,

  // 加班申请——申请
  submitOvertime: `${baseUrl}/overtime/submit`,

  // 补卡申请——分页
  getRepairCardPage: `${baseUrl}/repairCard/getPage`,

  // 补卡申请——添加
  addRepairCard: `${baseUrl}/repairCard/add`,

  // 补卡申请——详情
  getRepairCardByCode: `${baseUrl}/repairCard/getByCode`,

  // 补卡申请——修改
  updateRepairCard: `${baseUrl}/repairCard/update`,

  // 补卡申请——删除
  deleteRepairCardByCodes: `${baseUrl}/repairCard/deleteByCodes`,

  // 补卡申请——保存审批
  submitRepairCard: `${baseUrl}/repairCard/submit`,

  // 请假调休——可调休天数分页
  getAttendanceAdjustRestDays: `${baseUrl}/attendanceAdjust/getRestDays`,

  // 请假调休——查询可调休天数
  getRestDaysByCode: `${baseUrl}/attendanceAdjust/getRestDaysByCode`,

  // 请假调休——分页
  getAttendanceAdjustPage: `${baseUrl}/attendanceAdjust/getPage`,

  // 请假调休——添加
  addAttendanceAdjust: `${baseUrl}/attendanceAdjust/add`,

  // 请假调休——详情
  getAttendanceAdjustByCode: `${baseUrl}/attendanceAdjust/getByCode`,

  // 请假调休——修改
  updateAttendanceAdjust: `${baseUrl}/attendanceAdjust/update`,

  // 请假调休——删除
  deleteAttendanceAdjustByCodes: `${baseUrl}/attendanceAdjust/deleteByCodes`,

  // 请假调休——提交
  submitAttendanceAdjust: `${baseUrl}/attendanceAdjust/submit`,

  // 打卡记录——分页
  getClockRecordPage: `${baseUrl}/clockRecord/getPage`,

  // 考勤记录——分页
  getAttendanceRecordPage: `${baseUrl}/attendanceRecord/getPage`,

  // 考勤记录——导出
  exportAttendanceRecord: `${baseUrl}/attendanceRecord/export`,

  // 考勤报表——数据统计
  getExpenseItem: `${baseUrl}/salaryReport/getExpenseItem`,

  // 考勤报表——分页
  getSalaryReportPage: `${baseUrl}/salaryReport/getPage`,

  // 考勤报表——生成报表
  manualGenerateReport: `${baseUrl}/salaryReport/manualGenerateReport`,

  // 考勤报表——导出
  exportAttendanceReport: `${baseUrl}/salaryReport/export`,

  // 考勤结果报表——所有列表
  getAllResultReport: `${baseUrl}/resultReport/getAll`,

  // 考勤结果报表——生成报表
  generateResultReport: `${baseUrl}/resultReport/generate`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/AttendancePoint.js